<img [src]="spinnerUrl()" class="rotate not-selectable" draggable="false" [height]="size()" alt="progress spinner" />
